import { useAuthFetchWithResult } from '@e3dc-react/shell/Hooks/AuthFetch'
import { UseMutationResult } from '@tanstack/react-query'
import { deleteCompany } from '../api/company.api'
import { usePortalMutation } from 'src/Libs/api'

interface UseDeleteCompanyParams {
  onSuccess?: (vars: DeleteCompanyData) => void
  onError?: (vars: DeleteCompanyData) => void
}

interface DeleteCompanyData {
  id: number
}

type UseDeleteCompanyReturnType = (data: UseDeleteCompanyParams) => UseMutationResult<void | null, unknown, DeleteCompanyData>

/**
 * Custom hook to delete existing company records
 */
const useDeleteCompany: UseDeleteCompanyReturnType = ({ onError, onSuccess }) => {
  const authFetch = useAuthFetchWithResult()

  const deleteCompanyConfig = usePortalMutation({
    mutationFn: (vars: DeleteCompanyData) => deleteCompany(vars.id, authFetch),
    onSuccess: (_, vars) => onSuccess?.(vars),
    onError: (_, vars) => onError?.(vars),
  })

  return deleteCompanyConfig
}

export default useDeleteCompany
